import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TemplateGeneralInfo,
  TemplateInitialState,
  TemplateRequiredField,
  TemplateRoles,
  TemplateStatusType,
  TemplateType,
} from "../../../../types/template.types";

// ---- Initial State ----
const initialState: TemplateInitialState = {
  template: {},
};

// ---- Slice ----
const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    // Set or update template data
    setTemplateData: (state, action: PayloadAction<Partial<TemplateType>>) => {
      state.template = {
        ...action.payload,
      };
    },

    // Set or update general info (allow partial updates)
    setTemplateGeneralInfo: (
      state,
      action: PayloadAction<Partial<TemplateGeneralInfo>>,
    ) => {
      state.template = {
        ...state.template,
        ...action.payload,
      };
    },

    // Set required fields
    setTemplateRequiredFields: (
      state,
      action: PayloadAction<{ required_fields: TemplateRequiredField[] }>,
    ) => {
      state.template = {
        ...state.template,
        ...action.payload,
      };
    },

    // Set roles
    setTemplateRoles: (
      state,
      action: PayloadAction<{ ticket_roles: TemplateRoles[] }>,
    ) => {
      state.template = {
        ...state.template,
        ...action.payload,
      };
    },

    // Set status (active/inactive)
    setTemplateStatus: (state, action: PayloadAction<TemplateStatusType>) => {
      state.template = {
        ...state.template,
        status: action.payload,
      };
    },

    // Reset template
    resetTemplate: (state) => {
      state.template = {};
    },
  },
});

// ---- Exports ----
export const {
  setTemplateGeneralInfo,
  setTemplateRequiredFields,
  setTemplateRoles,
  setTemplateStatus,
  resetTemplate,
  setTemplateData,
} = templateSlice.actions;

export const templateReducer = templateSlice.reducer;
